import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../../../../../../../components/Header';
import { TopologyTitle } from '../../../../../../../../components/Headers/EditHeader/components/TopologyTitle';
import styles from './index.module.css';

export type ExportHeaderProps = {
  exportingTitle: string;
};

export const ExportHeader = ({
  exportingTitle,
}: ExportHeaderProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Header
      title={t('siteTitle')}
      left={
        <TopologyTitle
          title={exportingTitle}
          overrideClasses={styles.topologyTitle}
        />
      }
      id="export-header"
    />
  );
};
